import { Button, Form, Input, Modal, Select, Space } from "antd";
import { useGetCoustomerLogList } from "features/log/use-cases/get-logCustomer";
import { useUpdateCustomerLogDetail } from "features/log/use-cases/update-customer";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

type ModalLogtype = {
    showEditModal: boolean;
    setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
    apiData: any;
};

export const EditLogModalView = ({
    setShowEditModal,
    showEditModal,
    apiData,
}: ModalLogtype) => {
    const [form] = Form.useForm();
    const { id } = useParams();

    // Watch Entry Type
    const entryType = Form.useWatch("entryType", form);

    const payload1: any = {
        Flag: entryType === 1 ? "Customer" : "Supplier"
    }
    const { data } = useGetCoustomerLogList(payload1, {
        enabled: !!entryType,
    });
    const isSales = entryType === 1;
    const showInput = [1, 2, 3].includes(entryType);
    const { mutate, isLoading } = useUpdateCustomerLogDetail();

    /* ---------------- Prefill Form ---------------- */
    useEffect(() => {
        if (apiData) {
            form.setFieldsValue({
                vehicleNumber: apiData.vehicleNumber,
                driverName: apiData.driverName,
                entryType: apiData.entryType,

                // Dynamic field
                customer: apiData.entryType === 1 ? apiData.customerName : undefined,
                supplierId: apiData?.supplierId,
                driverId:apiData?.driverId,
                supplier:
                    apiData.entryType === 2 || apiData.entryType === 3
                        ? apiData.supplierName
                        : undefined,
            });
        }
    }, [apiData, form]);

    /* ---------------- Submit ---------------- */
    const onFinish = (values: any) => {
        const payload = {
            entryId: id,
            vehicleNumber: values.vehicleNumber,
            driverName: values.driverName,
            entryType: apiData?.entryType,
            supplierId: values?.supplierId,
            driverId: values?.driverId,
        };
        mutate(payload,{onSuccess:(data1:any)=>{
           if(data1?.rs==1){
               setShowEditModal(false);
           }
        }});
    };

    return (
        <Modal
            title="Log Edit"
            open={showEditModal}
            onCancel={() => setShowEditModal(false)}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                onValuesChange={(changed) => {
                    if (changed.entryType) {
                        // Reset dynamic fields when entry type changes
                        form.resetFields(["customer", "supplier"]);
                    }
                }}
            >
                {/* Vehicle */}
                <Form.Item
                    label="Vehicle Number"
                    name="vehicleNumber"
                    rules={[{ required: true, message: "Please enter vehicle number" }]}
                >
                    <Input />
                </Form.Item>

                {/* Driver */}
                <Form.Item
                    label="Driver Name"
                    name="driverName"
                    rules={[{ required: true, message: "Please enter driver name" }]}
                >
                    <Input />
                </Form.Item>

                  {/* Driver */}
                <Form.Item
                    label="Driver Id"
                    name="driverId"
                    rules={[{ required: true, message: "Please enter driver id" }]}
                >
                    <Input />
                </Form.Item>


                {/* Entry Type */}
                <Form.Item
                    label="Entry Type"
                    name="entryType"
                    hidden={true}
                    rules={[{ required: true, message: "Please select entry type" }]}
                >
                    <Select>
                        <Select.Option value={1}>Sales</Select.Option>
                        <Select.Option value={2}>Purchase</Select.Option>
                        <Select.Option value={3}>Store</Select.Option>
                    </Select>
                </Form.Item>

                {/* Dynamic Customer / Supplier */}
                {showInput && (
                    <Form.Item
                        key={isSales ? "customer" : "supplier"} // 🔥 important to remount
                        label={isSales ? "Customer" : "Supplier"}
                        name={'supplierId'}
                        rules={[
                            {
                                required: true,
                                message: `Please select ${isSales ? "customer" : "supplier"}`,
                            },
                        ]}
                    >
                        <Select
                            placeholder={`Select ${isSales ? "customer" : "supplier"}`}
                            options={data?.res?.commonList?.map((item: any) => ({
                                label: item.title,   // 👈 adjust based on API
                                value: item.id,     // 👈 adjust based on API
                            }))}
                        />
                    </Form.Item>
                )}

                {/* Buttons */}
                <Form.Item className="flex justify-end gap-2">
                    <Space>
                    <Button onClick={() => setShowEditModal(false)}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={isLoading}>
                        Save
                    </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};
